import React, { useRef, useMemo } from 'react';

import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  Drawer,
} from '@material-ui/core';
import { Check, Close } from '@material-ui/icons';
import { isUndefined, isEmpty, find } from 'lodash';
import PropTypes from 'prop-types';

import { Input, Select, DateTime } from '~/components/Form';
import { t, convertType } from '~/helpers';

import { MyForm, DrawerContent, DrawerActions } from './styles';

export default function Filter({
  open,
  close,
  fields,
  onSubmit,
  initials,
  search,
}) {
  const formRef = useRef(null);
  const isMobile = window.innerWidth <= 425;

  // render fields to filter
  const inFields = useMemo(
    () => fields.filter((field) => !isUndefined(field.filter)),
    [fields]
  );

  /**
   * convert object to input
   *
   * @param {Object} field
   */
  function renderFields(field) {
    const { id, label, filter } = field;
    const { type, options } = filter;

    const defOptions = [{ label: 'Todos', value: '' }];

    // include new options in array
    if (type === 'select') {
      defOptions.push(
        ...options.map((option) => ({
          label: option.value,
          value: option.label,
        }))
      );
    }

    switch (type) {
      case 'text':
      case 'number':
      case 'date':
      case 'time':
        return <Input name={id} label={label} type={type} />;
      case 'select':
        return <Select name={id} options={defOptions} label={label} />;
      case 'datetime':
      case 'initialdatetime':
      case 'finaldatetime':
        return <DateTime time name={id} label={label} />;
      default:
        return '';
    }
  }

  /**
   * serialize data, find type object and convert array
   *
   * @param {Object} values
   */
  async function handleSubmit(values) {
    const data = Object.keys(values).map((key) => ({
      name: key,
      type: convertType(find(fields, (field) => field.id === key).filter.type),
      value: values[key],
    }));

    await onSubmit({ fields: values, data });

    if (isMobile) close();
  }

  if (isMobile)
    return (
      <Dialog open={open} onClose={() => close()} fullScreen>
        <DialogContent>
          <MyForm
            ref={formRef}
            onSubmit={handleSubmit}
            initialData={isEmpty(search) ? initials : search}
          >
            {inFields.map((field) => renderFields(field))}
          </MyForm>
        </DialogContent>
        <DialogActions>
          <Button
            startIcon={<Check />}
            color="primary"
            variant="outlined"
            onClick={() => formRef.current.submitForm()}
          >
            {t('s.geral.botaoconfirmar')}
          </Button>

          <Button
            startIcon={<Close />}
            color="secondary"
            variant="outlined"
            onClick={() => close()}
          >
            {t('s.geral.botaocancelar')}
          </Button>
        </DialogActions>
      </Dialog>
    );

  return (
    <Drawer anchor="right" open={open} onClose={() => close()}>
      <DrawerContent>
        <MyForm
          ref={formRef}
          onSubmit={handleSubmit}
          initialData={isEmpty(search) ? initials : search}
        >
          {inFields.map((field) => renderFields(field))}
        </MyForm>

        <DrawerActions>
          <Button
            startIcon={<Check />}
            color="primary"
            variant="outlined"
            onClick={() => formRef.current.submitForm()}
          >
            {t('s.geral.botaoconfirmar')}
          </Button>

          <Button
            startIcon={<Close />}
            color="secondary"
            variant="outlined"
            onClick={() => close()}
          >
            {t('s.geral.botaocancelar')}
          </Button>
        </DrawerActions>
      </DrawerContent>
    </Drawer>
  );
}

Filter.propTypes = {
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  fields: PropTypes.arrayOf(PropTypes.any).isRequired,
  onSubmit: PropTypes.func.isRequired,
  initials: PropTypes.objectOf(PropTypes.any).isRequired,
  search: PropTypes.objectOf(PropTypes.any).isRequired,
};
